import { useRef, useState, useCallback } from "react";

/** Shared between ZoomableImage and swipe-to-dismiss / gallery handlers. */
export type MediaViewerGestureLock = {
  /** True while zoomed in / panning — parent swipes must be ignored. */
  blockSwipes: boolean;
};

export function useMediaViewerGestureLock() {
  return useRef<MediaViewerGestureLock>({ blockSwipes: false });
}

/** Reactive zoom flag for disabling gallery carousel / arrow navigation. */
export function useMediaViewerZoomState() {
  const imageZoomedRef = useRef(false);
  const [imageZoomed, setImageZoomed] = useState(false);

  const onZoomedChange = useCallback((zoomed: boolean) => {
    imageZoomedRef.current = zoomed;
    setImageZoomed(zoomed);
  }, []);

  const resetZoomed = useCallback(() => {
    imageZoomedRef.current = false;
    setImageZoomed(false);
  }, []);

  return { imageZoomed, imageZoomedRef, onZoomedChange, resetZoomed };
}

export function isMediaViewerSwipeBlocked(
  lock: MediaViewerGestureLock | undefined,
  maxTouches: number,
): boolean {
  return maxTouches >= 2 || Boolean(lock?.blockSwipes);
}
